import script from "./NewTaskLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewTaskLog.vue?vue&type=script&lang=ts&setup=true"

import "./NewTaskLog.vue?vue&type=style&index=0&id=0253082b&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0253082b"]])

export default __exports__